
// __TTD_ENV__ 是 TTDDeployWebpackPlugin 插件生成的 环境变量
// eslint-disable-next-line no-undef
const env = __TTD_ENV__; // __TTD_ENV__ // dev, test, live, prod

const configs = {
  dev: { // 开发环境
    baseUrl: 'https://devjzwsp.totodi.com', // 接口地址
    linkfaceProxyUrl: 'http://peys.totodi.com:37089', // linkface 的nginx 代理配置
  },
  test: { // 测试环境
    baseUrl: 'http://peys.totodi.com:27811',
    linkfaceProxyUrl: 'http://peys.totodi.com:37089',
  },
  testtx: { // 腾讯云测试环境
    baseUrl: 'https://petx.totodi.com',
    linkfaceProxyUrl: 'http://peys.totodi.com:37089',
  },
  jryhd: { // 金融云灰度测试环境
    baseUrl: 'http://graytest.totodi.com:13606',
    linkfaceProxyUrl: 'http://peys.totodi.com:37089',
  },
  live: { // 演示环境
    baseUrl: 'http://peys.totodi.com:17811',
    linkfaceProxyUrl: 'http://peys.totodi.com:37089',
  },
  prod: { // 线上
    baseUrl: 'http://pe.totodi.com:13811',
    linkfaceProxyUrl: 'http://pe.totodi.com:8502',
  },
};

const config = configs[env];

export default config;
